(function () {
  function initCardSliders() {
    // Prefer only on touch devices (avoid messing with desktop hover UX)
    var isTouch = window.matchMedia && window.matchMedia("(hover: none)").matches;
    if (!isTouch) return;

    if (!window.Swiper) return;

    document.querySelectorAll('[data-card-slider].swiper:not(.is-init)').forEach(function (el) {
      el.classList.add('is-init');

      var hasMulti = el.querySelectorAll('.swiper-slide').length > 1;

      new Swiper(el, {
        slidesPerView: 1,
        loop: false,
        watchOverflow: true,
        speed: 250,
        pagination: hasMulti
          ? { el: el.querySelector('.swiper-pagination'), clickable: true }
          : false,
      });
    });
  }

  document.addEventListener("DOMContentLoaded", initCardSliders);
  document.addEventListener("shopify:section:load", initCardSliders);
})();
